import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "sonner";
//blah blah
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Tunnels from "./pages/Tunnels";
import TunnelDetail from "./pages/TunnelDetail";
import ApiKeys from "./pages/ApiKeys";
import CustomDomains from "./pages/CustomDomains";
import CliInstall from "./pages/CliInstall";
import SettingsPage from "./pages/Settings";
import PricingPage from "./pages/Pricing";
import DocsPage from "./pages/Docs";
import Features from "./pages/Features";
import HowItWorks from "./pages/HowItWorks";
import StatusPage from "./pages/Status";
import PrivacyPage from "./pages/Privacy";
import TermsPage from "./pages/Terms";
import AdminPage from "./pages/Admin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import NgrokAlternative from "./pages/NgrokAlternative";

function PublicOnly({ children }) {
    const { user } = useAuth();
    if (user === null) return null;
    if (user) return <Navigate to="/app/tunnels" replace />;
    return children;
}

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/ngrok-alternative" element={<NgrokAlternative />} />
            <Route path="/compare/ngrok-vs-cloudflare-vs-synapselink" element={<NgrokAlternative />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/app" element={<Navigate to="/app/tunnels" replace />} />
            <Route path="/app/tunnels" element={<ProtectedRoute><Tunnels /></ProtectedRoute>} />
            <Route path="/app/tunnels/:tid" element={<ProtectedRoute><TunnelDetail /></ProtectedRoute>} />
            <Route path="/app/keys" element={<ProtectedRoute><ApiKeys /></ProtectedRoute>} />
            <Route path="/app/domains" element={<ProtectedRoute><CustomDomains /></ProtectedRoute>} />
            <Route path="/app/cli" element={<ProtectedRoute><CliInstall /></ProtectedRoute>} />
            <Route path="/app/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
            <Route path="/app/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0A0A0A", color: "#FAFAFA", border: "1px solid #27272A", borderRadius: 0, fontFamily: "JetBrains Mono, monospace" } }} />
                    <AppRoutes />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
